import { AuthGuard } from "@ssf/auth-components";
import { Loading, useTrackPageChange } from "@ssf/components";
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";

import { routes } from "../lib/routes.js";
import { TraditionalClubGuard } from "./TraditionalClubGuard.jsx";

const SelectTraditionalClubPage = lazy(
  () => import("../pages/SelectTraditionalClubPage.jsx"),
);
const TraditionalClubPage = lazy(
  () => import("../pages/TraditionalClubPage.jsx"),
);
const TraditionalMemberPage = lazy(
  () => import("../pages/TraditionalMemberPage.jsx"),
);
const TraditionalMemberRegistrationPage = lazy(
  () => import("../pages/TraditionalMemberRegistrationPage.jsx"),
);
const AddTraditionalMember = lazy(
  () => import("../pages/AddTraditionalMember.jsx"),
);
const AddExistingTraditionalMember = lazy(
  () => import("../pages/AddExistingTraditionalMember.jsx"),
);

export const Router = () => {
  useTrackPageChange();

  return (
    <Routes>
      <Route
        path={routes.addExistingMember}
        element={
          <AuthGuard autoSignin>
            <TraditionalClubGuard>
              {(club) => (
                <Suspense fallback={<Loading />}>
                  <AddExistingTraditionalMember key={club.id} club={club} />
                </Suspense>
              )}
            </TraditionalClubGuard>
          </AuthGuard>
        }
      />
      <Route
        path={routes.memberRegistration}
        element={
          <AuthGuard autoSignin>
            <TraditionalClubGuard>
              {(club) => (
                <Suspense fallback={<Loading />}>
                  <TraditionalMemberRegistrationPage
                    key={club.id}
                    club={club}
                  />
                </Suspense>
              )}
            </TraditionalClubGuard>
          </AuthGuard>
        }
      />
      <Route
        path={routes.addMember}
        element={
          <AuthGuard autoSignin>
            <TraditionalClubGuard>
              {(club) => (
                <Suspense fallback={<Loading />}>
                  <AddTraditionalMember key={club.id} club={club} />
                </Suspense>
              )}
            </TraditionalClubGuard>
          </AuthGuard>
        }
      />
      <Route
        path={routes.member}
        element={
          <AuthGuard autoSignin>
            <TraditionalClubGuard>
              {(club) => (
                <Suspense fallback={<Loading />}>
                  <TraditionalMemberPage club={club} />
                </Suspense>
              )}
            </TraditionalClubGuard>
          </AuthGuard>
        }
      />
      <Route
        path={routes.selectClub}
        element={
          <AuthGuard autoSignin>
            <Suspense fallback={<Loading />}>
              <SelectTraditionalClubPage />
            </Suspense>
          </AuthGuard>
        }
      />
      <Route
        path={routes.club}
        element={
          <AuthGuard autoSignin>
            <TraditionalClubGuard>
              {(club) => (
                <Suspense fallback={<Loading />}>
                  <TraditionalClubPage club={club} />
                </Suspense>
              )}
            </TraditionalClubGuard>
          </AuthGuard>
        }
      />
    </Routes>
  );
};
